/**
 * Marketing icons — small SVG primitives ported from `marketing_v2/home.jsx`
 * and `shared.jsx`. Server-component safe (no hooks, no event handlers).
 */

interface IconProps {
  size?: number;
  className?: string;
}

export function ArrowR({ size = 14, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M5 3 L9 7 L5 11"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconReports({ size = 22, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <rect x="3" y="3" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M7 8h8M7 11h8M7 14h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function IconCompass({ size = 22, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M11 3 V5 M11 17 V19 M3 11 H5 M17 11 H19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M13.5 8.5 L11 11 L8.5 13.5 L11 11 L13.5 8.5z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconSimulate({ size = 22, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <circle cx="7" cy="8" r="2.5" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="15" cy="8" r="2.5" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="11" cy="15" r="2.5" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M8.7 9.5 L9.6 13 M13.3 9.5 L12.4 13 M9 8.5 H13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Institutional research / value icon — column 1 of Differentiators. */
export function DiffIconValue({ size = 24, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <rect x="3" y="11" width="4" height="9" rx="1" stroke="currentColor" strokeWidth="1.6" />
      <rect x="10" y="6" width="4" height="14" rx="1" stroke="currentColor" strokeWidth="1.6" />
      <rect x="17" y="14" width="4" height="6" rx="1" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

/** Fundamentals / chart icon — column 2 of Differentiators. */
export function DiffIconFundamentals({ size = 24, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M5 19 L10 13 L13 16 L19 8"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="19" cy="8" r="1.5" fill="currentColor" />
    </svg>
  );
}

/** Transparency / audit icon — column 3 of Differentiators. */
export function DiffIconTransparency({ size = 24, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.6" />
      <path
        d="M8 8 L10 10 M16 8 L14 10 M8 16 L10 14 M16 16 L14 14"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}
